import { downloadEmptyInspectionDto } from '../../../types/inspection.dto';

export const DOWNLOAD_PDF = 'DOWNLOAD_PDF';
export const DOWNLOAD_PDF_SUCCESS = 'DOWNLOAD_PDF_SUCCESS';
export const DOWNLOAD_PDF_ERROR = 'DOWNLOAD_PDF_ERROR';
export const RESET_DOWNLOAD_PDF = 'RESET_DOWNLOAD_PDF';



export interface DownloadPdf {
    type: typeof DOWNLOAD_PDF,
    payload: downloadEmptyInspectionDto
}

export interface DownloadPdfSuccess {
    type: typeof DOWNLOAD_PDF_SUCCESS,
}

export interface DownloadPdfError {
    type: typeof DOWNLOAD_PDF_ERROR,
    payload: string | boolean,
}

export interface ResetDownloadPdf {
    type: typeof RESET_DOWNLOAD_PDF,
    payload: null,
}


export interface State {
    states: {
        loading: boolean,
        success: boolean,
        error: boolean | string
    },
}

export const initialState: State = {
    states: {
        loading: false,
        success: false,
        error: false,
    }
}

export type Actions = DownloadPdf | DownloadPdfSuccess | DownloadPdfError | ResetDownloadPdf;